import api from '../services/api';

export interface Address {
  street_address: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country: string | null;
}

export interface AddressUpdateRequest {
  street_address: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}

export const getUserAddress = async (): Promise<Address> => {
  try {
    const response = await api.get<Address>('/address/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch user address:', error);
    throw new Error('Failed to fetch user address');
  }
};

export const updateUserAddress = async (addressData: AddressUpdateRequest): Promise<Address> => {
  try {
    const response = await api.put<Address>('/address/update/', addressData);
    return response.data;
  } catch (error: any) {
    console.error('Failed to update user address:', error);
    
    // Handle specific backend validation errors
    if (error.response?.data?.non_field_errors) {
      throw new Error(error.response.data.non_field_errors[0]);
    }
    
    throw new Error('Failed to update user address');
  }
};

export const hasCompleteAddress = (address: Address): boolean => {
  return !!(
    address.street_address &&
    address.city &&
    address.state &&
    address.postal_code &&
    address.country
  );
}; 